import React from 'react';

import { link } from '@aline/routes';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AlineButton } from 'src/components/generic/AlineButton';
import { makeStyles } from 'tss-react/mui';

import { StepLayout } from '../StepLayout';

const useStyles = makeStyles()(theme => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    height: 320,
    justifyContent: 'center',
  },
  stepLayout: {
    width: 'inherit',
  },
}));

export function SaveAsDraft({ workflowId }: { workflowId: UUID }) {
  const navigate = useNavigate();
  const { classes } = useStyles();
  return (
    <StepLayout className={classes.stepLayout} title="Save as draft">
      <div className={classes.root}>
        <div>
          <Typography gutterBottom align="center" variant="subtitle1">
            Don’t want to send documents to anyone yet?
          </Typography>
          <Typography align="center" variant="body2">
            {'Click on "Go to draft" to go to the workflow page. All your progress will be saved.'}
          </Typography>
        </div>
        <AlineButton
          color="primary"
          variant="outlined"
          onClick={() => {
            navigate(link.WorkflowDetailTabSummary({ workflowId }));
          }}
        >
          Go to Draft
        </AlineButton>
      </div>
    </StepLayout>
  );
}
